// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.min.css'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
import VueMq from 'vue-mq'
import VueJWT from 'vuejs-jwt'
import Toolbar from './components/toolbar'
import App from './App'
import router from './router'
import store from './store'
import './filters/filters'

Vue.use(VueAxios, axios);
Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme: {
    primary: '#202959',
    secondary: '#4158BF',
    accent: '#57DEF4',
    success: '#007E33',
    error: '#CC0000',
    warning: '#FF8800',
    info: '#4158BF'
  },
  options: {
    customProperties: true
  }
})
Vue.use(Vuelidate)
Vue.use(VueMq, {
  breakpoints: {
    mobile: 600,
    tablet: 960,
    laptop: 1264,
    desktop: Infinity
  }
})
Vue.use(VueJWT, { keyName: 'user-token' })

Vue.config.productionTip = false
// Register components globally
// Vue.component('bread-crumbs', BreadCrumbs);
Vue.component('tool-bar', Toolbar)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js